import { IServiceFactory } from '../../common/types/service-factory';
import { ApiServiceFactoryBase } from './base/api-service-factory-base';
import { AIChatApiService, IAIChatApiService } from 'api/services/ai-chat-api-service';

export class AIChatApiServiceFactory extends ApiServiceFactoryBase implements IServiceFactory<IAIChatApiService> {
    public Create(): IAIChatApiService {
        return new AIChatApiService(this.apiServiceFactory.Create(), this.appConfigService);
    }
}
